import { emailAddress as emailAddressPattern } from "constants/regexExpressions";
import { fromEvent } from "rxjs";

const emailInput = document.querySelector("[data-registration-form-email]");
const phoneInput = document.querySelector("[data-registration-form-phone]");
const termsCheckbox = document.querySelector("[data-registration-form-terms]");
const submitButton = document.querySelector("[data-registration-form-submit]");


/**
 * Validates the registration form inputs.
 *
 * @returns {[HTMLElement]} An array of invalid input elements.
 */
function validateForm() {
  const invalidInputs = [];

  // Validate email
  if (!emailInput.value || !emailInput.value.match(emailAddressPattern)) {
    invalidInputs.push(emailInput);
  }

  // Validate phone
  // Phone number should be in the format (123) 456-7890
  // we only validate if the input is not empty
  if (phoneInput.value && !phoneInput.value.match(/^\(\d{3}\) \d{3}-\d{4}$/)) {
    invalidInputs.push(phoneInput);
  }

  // Validate terms checkbox
  if (!termsCheckbox.checked) {
    invalidInputs.push(termsCheckbox);
  }

  return invalidInputs;
}

/**
 * Hides all error messages by removing the error class from input wrappers.
 */
function hideErrorMessages() {
  const wrappers = document.querySelectorAll(
    "[data-registration-form-input-wrapper]"
  );
  wrappers.forEach((wrapper) =>
    wrapper.classList.remove("nhs-c-input__wrapper--error")
  );
}

/**
 * Shows error messages for invalid inputs by adding the error class to their wrappers.
 * @param {HTMLElement[]} invalidInputs
 */
function showErrorMessages(invalidInputs) {
  invalidInputs.forEach((input) => {
    const wrapper = input.closest("[data-registration-form-input-wrapper]");
    if (wrapper) {
      wrapper.classList.add("nhs-c-input__wrapper--error");
    }
  });
}

/**
 * Handles form validation on input blur and checkbox change events.
 */
const validationHandler = () => {
  const invalidInputs = validateForm();

  hideErrorMessages(); // Hide all error messages first
  // If there are invalid inputs, show error messages

  if (invalidInputs.length > 0) {
    showErrorMessages(invalidInputs);
    submitButton.disabled = true;
    return;
  }
  submitButton.disabled = false;
};


/**
 * Initializes the validation for the registration form.
 * Attaches event listeners for input validation and form submission.
 */
export default function initValidation() {
  // Attach validation to input events
  fromEvent(emailInput, "blur").subscribe(validationHandler);
  fromEvent(phoneInput, "blur").subscribe(validationHandler);
  fromEvent(termsCheckbox, "change").subscribe(validationHandler);
}
